import { DPoint } from "../../utils/extractLines"

export function splitIntoContiguousYearSegments(points: DPoint[]): DPoint[][] {
  if (points.length === 0) {
    return []
  }

  const segments: DPoint[][] = [[points[0]]]

  for (let index = 1; index < points.length; index += 1) {
    const previousPoint = points[index - 1]
    const currentPoint = points[index]
    const yearGap =
      currentPoint.date.getFullYear() - previousPoint.date.getFullYear()

    if (yearGap > 1) {
      segments.push([currentPoint])
      continue
    }

    segments[segments.length - 1].push(currentPoint)
  }

  return segments
}